<template>
  <block
    component-name="block-text-prose"
    body-class="grid grid-cols-12 gap-ui"
  >
    <txt-prose
      class="col-span-full laptop:col-start-2 laptop:col-end-12 desktop:col-start-3 desktop:col-end-11 extdesktop:col-start-4 extdesktop:col-end-10 w-full"
    >
      <div class="contents" v-html="$attrs.data.body.html"></div>
    </txt-prose>
  </block>
</template>
